import { render, staticRenderFns } from "./SettingButton.vue?vue&type=template&id=6188b157"
import script from "./SettingButton.vue?vue&type=script&lang=js"
export * from "./SettingButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports